// extracted by mini-css-extract-plugin
export default {"actionButton":"UserTransferHistory_actionButton__6cWjj"};